import { PERSIST_ROOT_KEY } from "../data/local-storage-constants";

export const OLD_STATE_KEY = "state";
// Keys that are persisted by redux-persist (matches store.ts persistConfig,
// excludes blacklisted reducers like ristaCardReducer).
const KNOWN_REDUCER_KEYS = [
  "accountingReducer",
  "accountsReducer",
  "addOnsReducer",
  "brandsReducer",
  "bulkUploadReduer",
  "businessReducer",
  "catalogReducer",
  "channelMenuReducer",
  "chargesAndDiscountsReducer",
  "dashboardReducer",
  "galleryReducer",
  "itemSchedulesReducer",
  "loginReducer",
  "menusReducer",
  "outletStatusReducer",
  "pnlStatementReducer",
  "reportsReducer",
  "requestHeadersReducer",
  "savedReportReducer",
  "taxesReducer",
  "commonReducer",
  "tablesReducer",
  "inventoryReducer",
  "recommenderReducer",
] as const;

/**
 * One-time migration: reads the legacy "state" localStorage key written by
 * the old manual loadState/saveState approach and writes it into the format
 * expected by redux-persist (key "persist:root").
 * Only copies known, valid reducer keys — unknown or blacklisted keys are
 * silently dropped.
 * Safe to call multiple times — it is a no-op if the old key is absent.
 */
export const migrateFromLegacyState = (): void => {
  try {
    const oldState = localStorage.getItem(OLD_STATE_KEY);
    if (!oldState) return;

    const parsed: Record<string, unknown> = JSON.parse(oldState);
    const migrated: Record<string, string> = {};

    KNOWN_REDUCER_KEYS.forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(parsed, key) && parsed[key] !== undefined) {
        migrated[key] = JSON.stringify(parsed[key]);
      }
    });

    // redux-persist reads _persist to determine the stored schema version.
    migrated["_persist"] = JSON.stringify({ version: 1, rehydrated: false });

    localStorage.removeItem(OLD_STATE_KEY);
    localStorage.setItem(PERSIST_ROOT_KEY, JSON.stringify(migrated));
  } catch {
    // ignore migration errors — a fresh state will be used instead
  }
};
